const antlr4 = require("./antlr4/index");
const tempHCPLexer = require("./HCPGrammarLexer"); //HCP changes: Changed the variable to get the properties of HCPGrammarLexer.
//Also in code the properties are accessed using 'tempHCPLexer.HCPGrammarLexer'.

function JavaScriptBaseLexer(input) {
  antlr4.Lexer.call(this, input);

  this.scopeStrictModes = new Array();
  this.lastToken = null;
  this.useStrictDefault = false;
  this.useStrictCurrent = false;
}

JavaScriptBaseLexer.prototype = Object.create(antlr4.Lexer.prototype);

JavaScriptBaseLexer.prototype.getStrictDefault = function() {
  return this.useStrictDefault;
};

JavaScriptBaseLexer.prototype.setUseStrictDefault = function(value) {
  this.useStrictDefault = value;
  this.useStrictCurrent = value;
};

JavaScriptBaseLexer.prototype.IsSrictMode = function() {
  return this.useStrictCurrent;
};

JavaScriptBaseLexer.prototype.getCurrentToken = function() {
  return antlr4.Lexer.prototype.nextToken.call(this);
};

JavaScriptBaseLexer.prototype.nextToken = function() {
  var next = antlr4.Lexer.prototype.nextToken.call(this);

  if (next.channel === antlr4.Token.DEFAULT_CHANNEL) {
    this.lastToken = next;
  }
  return next;
};

JavaScriptBaseLexer.prototype.ProcessOpenBrace = function() {
  this.useStrictCurrent =
    this.scopeStrictModes.length > 0 && this.scopeStrictModes[0]
      ? true
      : this.useStrictDefault;
  this.scopeStrictModes.push(this.useStrictCurrent);
};

JavaScriptBaseLexer.prototype.ProcessCloseBrace = function() {
  this.useStrictCurrent =
    this.scopeStrictModes.length > 0
      ? this.scopeStrictModes.pop()
      : this.useStrictDefault;
};

JavaScriptBaseLexer.prototype.ProcessStringLiteral = function() {
  if (
    this.lastToken !== undefined &&
    (this.lastToken === null ||
      this.lastToken.type === tempHCPLexer.HCPGrammarLexer.OpenBrace)
  ) {
    const text = this._input.strdata.slice(0, "use strict".length);
    if (text === '"use strict"' || text === "'use strict'") {
      if (this.scopeStrictModes.length > 0) {
        this.scopeStrictModes.pop();
      }
      this.useStrictCurrent = true;
      this.scopeStrictModes.push(this.useStrictCurrent);
    }
  }
};

JavaScriptBaseLexer.prototype.IsRegexPossible = function() {
  if (this.lastToken === null) {
    return true;
  }

  switch (this.lastToken.type) {
    case tempHCPLexer.HCPGrammarLexer.Identifier:
    case tempHCPLexer.HCPGrammarLexer.NullLiteral:
    case tempHCPLexer.HCPGrammarLexer.BooleanLiteral:
    case tempHCPLexer.HCPGrammarLexer.This:
    case tempHCPLexer.HCPGrammarLexer.CloseBracket:
    case tempHCPLexer.HCPGrammarLexer.CloseParen:
    case tempHCPLexer.HCPGrammarLexer.OctalIntegerLiteral:
    case tempHCPLexer.HCPGrammarLexer.DecimalLiteral:
    case tempHCPLexer.HCPGrammarLexer.HexIntegerLiteral:
    case tempHCPLexer.HCPGrammarLexer.StringLiteral:
    case tempHCPLexer.HCPGrammarLexer.PlusPlus:
    case tempHCPLexer.HCPGrammarLexer.MinusMinus:
      return false;
    default:
      return true;
  }
};

module.exports.JavaScriptBaseLexer = JavaScriptBaseLexer;
